import { useTranslation } from '@eti/providers';
import { ProductCardLayoutType } from '../../common/models/product';
import SmallSimpleVisa from './SmallSimpleVisa';
import MainSimpleVisa from './MainSimpleVisa';
import { jsx as _jsx } from "react/jsx-runtime";
const SimpleVisa = props => {
  const {
    t
  } = useTranslation();
  const newStructureProps = {
    ...props,
    travelerLabel: t('Postbooking.Traveler.Description')
  };
  switch (props.layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallSimpleVisa, {
        ...newStructureProps
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainSimpleVisa, {
        ...newStructureProps
      });
  }
};
export default SimpleVisa;
//# sourceMappingURL=SimpleVisa.js.map